export default __webpack_public_path__ + "static/media/christian_video.fa1a8a42.mov";